/**
 * Detail Addon Page.
 */
import Addon from '@shared/classes/addon';
import Channel from '@shared/classes/channel';
import Plan from '@shared/classes/plan';
import TDetailAddon from '../../templates/detailAddon';
import addonRequest from '@shared/api/addons/addonRequest';
import channelsAddonsRequest from '@shared/api/moreContent/channelsAddonsRequest';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';

/**
 * Displays the detail addon page with the addon and channels.
 */
export default function DetailAddon() {
  const currentParams = useAppSelector(selectCurrentParams);
  const [addon, setAddon] = useState<Addon>(
    (currentParams as { asset: Addon }).asset
  );
  const [channels, setChannels] = useState<Channel[] | null>([]);
  const [error, setError] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    addonRequest((currentParams as { asset: Addon }).asset).then(
      (remoteAddon: Addon | null) => {
        if (remoteAddon) {
          setAddon(remoteAddon);
          setError(false);
        } else {
          setError(true);
        }
      }
    );
    channelsAddonsRequest(
      (currentParams as { asset: Addon })?.asset?.addon || '',
      true,
      (addon?.plan as Plan)?.id || (addon?.plan as unknown as string)
    ).then((channels: Channel[] | null) => {
      if (channels) {
        setChannels(channels);
      } else {
        setChannels(null);
      }
    });
  }, []);

  return <TDetailAddon error={error} asset={addon} channels={channels} />;
}
